/**
 * 절차 CanvasTexture 공용 유틸(screens.ts / officeTextures.ts 공유).
 * 캔버스 생성 + CanvasTexture 마감(색공간/랩/이방성)을 한 곳에 모은다.
 */
import * as THREE from 'three';

/** 2D 캔버스 + 컨텍스트 생성(컨텍스트 실패 시 throw). */
export function makeCanvas(w: number, h: number): { canvas: HTMLCanvasElement; ctx: CanvasRenderingContext2D } {
  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('2d context 생성 실패');
  return { canvas, ctx };
}

export interface TexOpts {
  /** 기본 ClampToEdge. 타일링 텍스처는 RepeatWrapping. */
  wrap?: THREE.Wrapping;
  /** 이방성 필터링(기본 4). */
  aniso?: number;
}

/** 캔버스 → SRGB CanvasTexture. wrap/aniso는 호출부별로 지정(기본 ClampToEdge/4). */
export function toTexture(canvas: HTMLCanvasElement, opts: TexOpts = {}): THREE.CanvasTexture {
  const tex = new THREE.CanvasTexture(canvas);
  tex.colorSpace = THREE.SRGBColorSpace;
  tex.wrapS = tex.wrapT = opts.wrap ?? THREE.ClampToEdgeWrapping;
  tex.anisotropy = opts.aniso ?? 4;
  return tex;
}
